// The address fields, their lookups (states, cities, post codes, autocomplete)
// and Tom Select live in the engine's AddressFields component
// (basics/addressFields.js); here only the checkout's country rows are kept.
export default function useCartAddress() {
    function selectCountry(ctx, event) {
        loadShipping(ctx, event.target.value);
    }

    function selectInvoiceCountry(ctx, event) {
        const element = (window.cartConfig?.invoiceCountries ?? window.cartData?.invoiceCountries ?? []).find((item) => String(item.id) === String(event.target.value));
        if (element) {
            ctx.countryInvoice.code = element.code;
            ctx.countryInvoice.needPost = element.need_post_code;
            ctx.countryInvoice.needArea = element.need_area;
            ctx.countryInvoice.is_eu = element.is_eu;
            ctx.countryInvoice.postLocalName = element.post_code_local_name;
            ctx.countryInvoice.addressStyle = element.address_style;
            ctx.countryInvoice.needState = element.need_state;
            ctx.countryInvoice.stateType = element.state_type;
            ctx.countryInvoice.postRegex = element.post_code_regex;
            ctx.countryInvoice.houseRegex = element.house_regex;
        }
    }

    function loadShipping(ctx, value) {
        ctx.savedShipping.package_point = "";
        const element = (window.cartConfig?.countries ?? window.cartData?.countries ?? []).find((item) => String(item.id) === String(value));
        if (element) {
            ctx.countryShipping.needPost = element.need_post_code;
            ctx.countryShipping.needArea = element.need_area;
            ctx.countryShipping.is_eu = element.is_eu == 1;
            ctx.countryShipping.postLocalName = element.post_code_local_name;
            ctx.countryShipping.addressStyle = element.address_style;
            ctx.countryShipping.needState = element.need_state;
            ctx.countryShipping.stateType = element.state_type;
            ctx.countryShipping.code = element.code;
            ctx.countryShipping.postRegex = element.post_code_regex;
            ctx.countryShipping.houseRegex = element.house_regex;

            ctx.latitude = Number.parseFloat(element.latitude);
            ctx.longitude = Number.parseFloat(element.longitude);
            ctx.zoom = Number.parseFloat(element.zoom);
        }
        ctx.countryShippingError = false;
        if (ctx.shipping !== null && ctx.shipping.country_id != value) {
            ctx.shipping = null;
        }
    }

    function changeCountry(ctx, code) {
        for (const option of ctx.paymentButtonSettings.countries) {
            if (option.code.toUpperCase() === code.toUpperCase()) {
                ctx.countryShipping.code = option.code;
                ctx.countryShipping.id = option.id;
                ctx.countryShipping.needArea = option.need_area;
            }
        }
    }

    return {
        selectCountry,
        selectInvoiceCountry,
        loadShipping,
        changeCountry,
    };
}